import { GENERIC_ANALYTICS_EVENTS } from 'Utilities/analytics/analyticsGenericEvents';

type ctaProps = {
  vrm: string;
}

export const UPDATED_VALUATION = 'Updated Valuation page';

export const SP_UPDATED_VALUATION = Object.freeze({
  CONFIRM_PRICE_EXPIRED: ({ vrm }: ctaProps) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'Confirm my price',
    category: UPDATED_VALUATION,
    name: 'confirm_price_submit_expired_price',
    url: `/${vrm}/profile/valuation`,
  }),
});
